import { FC } from 'react';

interface NotFoundProps {}

/**
 * NotFound
 * @param props NotFoundProps
 * @returns
 */
const NotFound: FC<NotFoundProps> = (props) => {

  return <></>;
};

export default NotFound;
